var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"sidebat"},[_c('Sidebar')],1),_c('div',{staticClass:"content",class:{ small: _vm.isCollapse }},[_c('div',{staticClass:"footer"},[_c('Footer')],1),_c('div',{staticClass:"con"},[_c('Content',{attrs:{"isCollapse":_vm.isCollapse},on:{"changeShow":_vm.changeShow}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }